import React, { createContext, useContext } from 'react';
import { useKeycloak } from '../hooks/useKeycloak';

const AuthContext = createContext({
  initialized: false,
  authenticated: false,
  token: null,
  tokenParsed: null,
  refreshToken: null,
  userInfo: null,
  showSessionExpiredModal: false,
  setShowSessionExpiredModal: () => null,
  login: () => null,
  logout: () => null,
  register: () => null,
  accountManagement: () => null,
  updateToken: minValidity => null,
  isTokenExpired: minValidity => null
});

export const AuthProvider = ({ children }) => {
  const keycloak = useKeycloak();

  return (
    <AuthContext.Provider value={keycloak}>{children}</AuthContext.Provider>
  );
};

export const useKeycloakContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error(
      'useKeycloakContext must be used within a KeycloakProvider'
    );
  }
  return context;
};
